import React, { ComponentProps } from "react";

import { CardRoot } from "./styles";

interface RootProps extends ComponentProps<"div"> {
  isActive?: boolean;
  children: React.ReactNode;
}

export const Root = ({ children, isActive = false, ...rest }: RootProps) => {
  return (
    <CardRoot {...rest} isActive={isActive}>
      {children}
    </CardRoot>
  );
};
